window.addEventListener('DOMContentLoaded', function () {

  if (document.getElementById('kuProListing')) {

    addClassToBody('klevu-search');

    createNewHeaderAndFilterButtons();

  }


}, true);

var firstVisit = true;

var klevu_enableLandingAutoScroll = true;


var klevu_uc = {
  landingFilters: {
    loadingFiltersFor: "search-query",
    // function for showing filters from the given xml
    showFilters: function (filters) {
      var filterBox = document.getElementById('kuFilters'),
        i, len, j = 0,
        k = 0,
        filterBoxIds = new Array(),
        multiselectClass = '',
        filterByDoc = klevu_commons.isMobileDevice() ? document.getElementById("kuFilterRefineMobile") : document.getElementById("klevuNarrowByLabel");

      klevuLandingFilterTxt = '';
      filterBox.innerHTML = '';

      if ('undefined' !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
        multiselectClass = ' kuMulticheck';
      }
      // if filters are found in the received xml,
      // show the filters based on their type.
      if (filters && filters.length > 0) {
        filterBox.className = "kuFilters" + multiselectClass;
        for (i = 0, len = filters.length; i < len; i++) {
          if (filters[i].key === 'Price Range' && !klevu_showPrices) {
            continue;
          }
          filterBoxIds[j] = klevu_landingFilters.displayFiltersData(filters[i]);
          j++;
        }
        filterBox.innerHTML = klevuLandingFilterTxt;
        if ('undefined' !== typeof filterByDoc && filterByDoc) {
          if (klevuLandingFilterTxt.trim().length === 0) {
            filterByDoc.style.display = "none";
          } else {
            filterByDoc.style.display = "block";
          }
        }

        for (i = 0, len = filterBoxIds.length; i < len; i++) {
          if (filterBoxIds[i] && filterBoxIds[i].trim() != '') {
            document.getElementById(filterBoxIds[i]).style.height = "auto";
          }
        }

        //if( 'undefined' !== typeof klevu_userOptions.landingFilterPosition && klevu_userOptions.landingFilterPosition === 'top' ){
        j = 0;
        for (k = 0, len = filters.length; k < len; k++) {
          var key = filters[k].key.replace(' ', '_'),
            filterOptions = filters[k].options;
          for (var i = 0; i < filterOptions.length; i++) {
            var selected = filterOptions[i].isSelected,
              kuid = i + key + '~text';
            if (selected.trim() === 'true') {
              klevu_landingFilters.showSelectedFilter(kuid, filterOptions[i].name, j, filters[k].label);
              j++;
            }
          }
        }
        if ('undefined' !== typeof klevu_showPriceSlider && klevu_showPriceSlider &&
          klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1) {
          klevu_landingFilters.showSelectedFilter(null, klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0], j, null, 'Price-Range');
          j++;
        }
        if (j === 0) {
          klevu_landingFilters.showSelectedFilter(null, null, -1);
        }
        //}
        //below three lines solve rendering issue for mac browsers like chrome and safari
        filterBox.style.display = 'none';
        filterBox.offsetHeight;
        filterBox.style.display = 'block';
        if (document.getElementById('kuFilterRefineMobile') && klevu_commons.isMobileDevice() &&
          (!klevu_userOptions.checkScreenSizeForShowingFiltersInMobile || screen.width < 768)) {
          klevu_landingFilters.showFiltersOnMobile(!(j === 0));
        }
      } else {
        filterBox.className = "kuFilters disableKuFilter" + multiselectClass;
      }
    },

    // function for showing other filters
    displayFiltersData: function (filter) {
      if (filter) {
        var labelToPut = klevu_translateFilterLabel(filter.label).toUpperCase(),
          pricingFilter = false,
          msrpFilter = false,
          filterBox = '',
          filterOptions = filter.options,
          key = filter.key.replace(' ', '_'),
          label,
          inStockFilter = false,
          isAnyOptionSelected = false,
          truncatedLabel,
          hoverClass = "kuHover";

        if (filter.label.toLowerCase() === 'price range') {
          pricingFilter = true;
        }

        if (filter.label === 'MSRP') {
          msrpFilter = true;
        }

        if (filter.key === 'inStock') {
          inStockFilter = true;
        }

        if (klevu_commons.isMobileDevice()) {
          hoverClass = "";
        }

        if (filterOptions.length > 6) {
          filterBox += '<div class="kuFilterBox ' + hoverClass + '" id="kuFilterBox-' + key + '">';
        } else {
          filterBox += '<div class="kuFilterBox ' + hoverClass + '" style="height:auto;" id="kuFilterBox-' + key + '">';
        }
        filterBox += '<div class="kuFilterHead kuCollapse"' +
          ' id="kuFilterHead-' + key +
          '" onclick="klevu_landingFilters.collapseExpand(' +
          ' \'kuFilterHead-' + key + '\', \'kuFilterNames-' + key +
          '\', \'kuShowOpt-' + key + '\', \'kuHideOpt-' +
          key + '\', \'kuFilterBox-' + key +
          '\' );">' + labelToPut + '<span class="kuFilterHead__mark_closed">+</span><span class="kuFilterHead__mark_opened">-</span>' + '</div>' +
          '<div class="kuFilterNames" id="kuFilterNames-' +
          key + '">' + '<ul>';

        for (var i = 0, len = filterOptions.length; i < len; i++) {
          var selected = filterOptions[i].isSelected,
            kuid = i + key + '~text',
            kuClass = '',
            kuCounterClass = 'kuFilterTotal',
            counterText = filterOptions[i].count,
            onclickCall = 'klevu_landingFilters.sendQuery(\'' + kuid + '\', true );';

          if (selected.trim() === 'true') {
            kuClass = 'kuSelected';
            kuCounterClass = 'kuFilterCancel';
            if ('undefined' !== typeof klevu_multiSelectFilters && klevu_multiSelectFilters) {
              counterText = filterOptions[i].count;
              isAnyOptionSelected = true;
            } else {
              counterText = 'X';
            }
            onclickCall = 'klevu_landingFilters.cancelFilter(\'' + kuid + '\'); ';
          }

          label = filterOptions[i].name;

          if (msrpFilter && klevu_apiKey === 'klevu-14267110898901285') {
            if (label.trim().length > 0) {
              label = '$' + Number(label).toFixed(2);
            }
          }

          if (inStockFilter && klevu_apiKey === 'klevu-14268586701841383') {
            label = label.replace("No", "Ei").replace("Yes", "Kyllä");
          }


          if (pricingFilter) {
            label = klevu_commons.replaceCurrencyWithItsSymbol(label, klevu_storeLandingCurrency);
            truncatedLabel = label;
            label = '';
          } else {
            if (klevu_userOptions.truncateFilterLabel) {
              truncatedLabel = label.trunc(18);
            } else {
              truncatedLabel = label;
            }
          }

          filterBox += '<li id="' + i + key + '" class="' + kuClass +
            '"><a href="javascript:void(0);" onclick="' +
            onclickCall + '" title="' + label + '"><span class="kuFilterLabel">' +
            truncatedLabel.toLowerCase() + '</span><span class="' +
            kuCounterClass + '">' + counterText + '</span></a></li>' +
            '<input type="hidden" id="' + kuid + '" value="' +
            klevu_commons.escapeHtml(filterOptions[i].value) + '"/>';
        }
        filterBox += '</ul></div></div>';

        // if( filterOptions.length > 6 ){
        //   if( isAnyOptionSelected ){
        //     filterBox = filterBox.replace('<div class="kuFilterBox '+hoverClass+'" id="kuFilterBox-' + key + '">',
        //                                 '<div class="kuFilterBox '+hoverClass+'" style="height:auto;" id="kuFilterBox-' + key + '">');
        //   } else{
        //     filterBox += '<div class="kuShowOpt" id="kuShowOpt-' + key +
        //                '" style="display:block;text-align:center;">' +
        //                '<a href="javascript:klevu_landingFilters.showAll( \'kuFilterBox-' + key +
        //                '\' );" title="' + klevu_uiLabels.showMore + '"><img src="' +
        //                klevu_userOptions.viewMoreImageUrl +
        //                '" alt="' + klevu_uiLabels.showMore + '"/></a></div><div class="kuHideOpt" id="kuHideOpt-' + key +
        //                '" style="display:none;text-align:center;">' +
        //                '<a href="javascript:void(0);" onclick="klevu_landingFilters.hideAll(\'kuFilterBox-' + key +
        //                '\');" title="' + klevu_uiLabels.showLess + '"><img src="' +
        //                klevu_userOptions.viewLessImageUrl + '" alt="' + klevu_uiLabels.showLess + '"/></a></div>';
        //   }
        // }
        klevuLandingFilterTxt += filterBox;
        if (filterOptions.length > 0 && filterOptions.length < 6) {
          return 'kuFilterBox-' + key;
        }
      }
    },

    displayPricingSlider: function () {
      var labelToPut = klevu_translateFilterLabel('PRICE RANGE').toUpperCase(),
        filterBox = '',
        filterOptions = 1,
        key = 'Price-Range',
        kuid,
        i = 0,
        len, selected,
        kuClass, kuCounterClass,
        counterText, onclickCall,
        label,
        pricingFilterClass = 'klevuPriceRangeSlider';

      if (filterOptions.length > 6) {
        filterBox += '<div class="kuFilterBox" id="kuFilterBox-' + key + '">';
      } else {
        filterBox += '<div class="kuFilterBox" style="height:auto;" id="kuFilterBox-' + key + '">';
      }
      filterBox += '<div class="kuFilterHead kuCollapse"' +
        ' id="kuFilterHead-' + key +
        '" onclick="klevu_landingFilters.collapseExpand(' +
        ' \'kuFilterHead-' + key + '\', \'kuFilterNames-' + key +
        '\', \'kuShowOpt-' + key + '\', \'kuHideOpt-' +
        key + '\', \'kuFilterBox-' + key +
        '\' );">' + labelToPut + '</div>' +
        '<div class="kuFilterNames" id="kuFilterNames-' +
        key + '">';

      if ('undefined' !== typeof klevu_current_version && klevu_current_version) {
        klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, '2.0.2');
        if (!isNaN(klevuPluginVersion) && klevuPluginVersion >= 0) {
          pricingFilterClass = 'kuPriceRangeSlider';
        }
        klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, '2.0.0');
        if (!isNaN(klevuPluginVersion) && klevuPluginVersion < 0) {
          klevuPluginVersion = klevu_commons.compareVersionNumbers(klevu_current_version, '1.2.5');
          if (!isNaN(klevuPluginVersion) && klevuPluginVersion >= 0) {
            pricingFilterClass = 'kuPriceRangeSlider';
          }
        }
      }
      if ('undefined' !== typeof klevu_shopifyStore && klevu_shopifyStore) {
        pricingFilterClass = 'kuPriceRangeSlider';
      }
      filterBox += '<div class="' + pricingFilterClass + '"><div id="ku-price-range"></div>';
      filterBox += '<div > <span id="ku-from-price"></span>&nbsp; <span id="ku-to-price"></span></div></div>';
      filterBox += '</div></div>';

      return filterBox;
    },

    // function for sending query for the selected filter
    sendQuery: function (kuid, first) {
      var selectedFilters,
        doc = document,
        formattedFilters = '',
        predefinedFilters = '',
        filtersBox = doc.getElementById('kuFilters'),
        checkBoxes,
        priceFilter = '';
      if (first) {
        doc.getElementById(kuid.split('~')[0]).className = 'kuSelected';
      }
      if ('undefined' !== typeof klevu_userFilterResults) {
        predefinedFilters = klevu_userFilterResults;
      }
      checkBoxes = getElementsByClassName('kuSelected', 'li');

      selectedFilters = '';
      for (var i = 0, len = checkBoxes.length; i < len; i++) {
        formattedFilters = klevu_commons.unescapeHtml(doc.getElementById(checkBoxes[i].id +
          '~text').value);
        if (predefinedFilters.indexOf(formattedFilters) !== -1) {
          continue;
        }
        if (selectedFilters.trim() === '') {
          selectedFilters += formattedFilters;
        } else {
          selectedFilters += ";;" + formattedFilters;
        }
      }
      if ('undefined' !== typeof klevu_showPriceSlider && klevu_showPriceSlider &&
        klevu_userOptions.selectedLandingFilters.indexOf("klevu_price") !== -1) {
        priceFilter = ";;" + klevu_userOptions.selectedLandingFilters.match(/klevu_price:[0-9.\- ]*;*/)[0];
      }
      klevu_userOptions.selectedLandingFilters = selectedFilters + priceFilter;
      if (klevu_addSelectedFiltersToUrl) {
        klevu_commons.addSelectedFiltersToPageUrl(klevu_userOptions.selectedLandingFilters, klevu_productFilterParam);
      }
      klevu_pagination.landingStartPosition = 0;
      if ('undefined' === typeof klevu_multiSelectFilters || !klevu_multiSelectFilters) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      //klevu_lpShowLoader();
      if (doc.getElementById("kuProductContent")) {
        doc.getElementById('kuProductContent').style.opacity = "0.3";
      }
      klevu_landingFilters.loadingFiltersFor = "filter-selection";
      klevu_search.fetchResults(doc.getElementById('searchedKeyword').value, 'klp');
      return false;
    },

    // function for showing all filters
    showAll: function (boxId, link) {
      var doc = document,
        box = doc.getElementById(boxId),
        key = boxId.substring(boxId.indexOf('-') + 1, boxId.length);

      box.style.height = "auto";
      box.style.overflow = "visible";
      doc.getElementById('kuShowOpt-' + key).style.display = "none";
      doc.getElementById('kuHideOpt-' + key).style.display = "block";
    },

    // function for hiding filters
    hideAll: function (boxId) {
      var doc = document,
        box = doc.getElementById(boxId),
        key = boxId.substring(boxId.indexOf('-') + 1, boxId.length);

      box.style.height = "";
      box.style.overflow = "hidden";
      doc.getElementById('kuShowOpt-' + key).style.display = "block";
      doc.getElementById('kuHideOpt-' + key).style.display = "none";
    },

    showSelectedFilter: function (kuid, selectedFilter, i, filterLabel, filterType) {
      var doc = document,
        selectedFilterDoc = doc.getElementById('ku-search-filter-tags'),
        clearAllEl = doc.getElementById('kuClearAllFilters'),
        filterHeadText = '',
        priceFilter = '';
      if (selectedFilterDoc) {
        if (i === -1) {
          selectedFilterDoc.innerHTML = "";
          return;
        }
        if (i === 0) {
          selectedFilterDoc.innerHTML = "";
        }
        if (filterLabel) {
          filterHeadText = filterLabel + " : ";
        }
        if (undefined !== typeof filterType && filterType === 'Price-Range') {
          if (!doc.getElementById('kuPriceRangeTag')) {
            selectedFilter = selectedFilter.split(':')[1];
            filterHeadText = klevu_translateFilterLabel('PRICE RANGE').toUpperCase() + " : ";
            selectedFilterDoc.innerHTML += '<span class="ku-search-filter-tag" id="kuPriceRangeTag"> ' + filterHeadText + selectedFilter + ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelPriceSliderFilter(); ">x</a></span> ';
          }
        } else {
          selectedFilterDoc.innerHTML += '<span class="ku-search-filter-tag"> ' + filterHeadText + selectedFilter + ' <a class="ku-search-filter-remove" onclick="klevu_landingFilters.cancelFilter(\'' + kuid + '\'); ">x</a></span> ';
        }
        if (doc.getElementById('kuClearAllFilters')) {
          doc.getElementById('kuClearAllFilters').parentNode.removeChild(doc.getElementById('kuClearAllFilters'));
        }
        selectedFilterDoc.innerHTML += '<span class="ku-search-filter-remove-all" id="kuClearAllFilters" onclick="klevu_landingFilters.clearAllFilters(); "><a> ' + klevu_uiLabels.clearAll + '</a></span>';
      }

    },

    // function for removing a filter selection
    cancelFilter: function (id) {
      document.getElementById(id.split('~')[0]).className = "";
      klevu_landingFilters.sendQuery(id, false);
    },

    cancelPriceSliderFilter: function () {
      klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(/klevu_price:[0-9.\- ]*;*/, '');
      klevu_landingFilters.sendQuery('', false);
    },

    clearAllFilters: function () {

      document.getElementById('kuProListing').classList.remove('filter_selected');
      document.getElementById('kuMainContainer').classList.remove('filter_opened');

      var checkBoxes = getElementsByClassName('kuSelected', 'li');
      for (var i = 0, len = checkBoxes.length; i < len; i++) {
        checkBoxes[i].className = "";
      }
      if (document.getElementById('kuPriceRangeTag')) {
        klevu_userOptions.selectedLandingFilters = klevu_userOptions.selectedLandingFilters.replace(/klevu_price:[0-9.\- ]*;*/, '');
      }
      klevu_landingFilters.sendQuery('', false);
    },

    // function for expanding/collapsing filter boxes
    collapseExpand: function (mainId, nameId, showId, hideId, filterId) {
      var doc = document,
        mainBox = doc.getElementById(mainId),
        nameBox = doc.getElementById(nameId),
        showBox = doc.getElementById(showId),
        hideBox = doc.getElementById(hideId),
        filterBox = doc.getElementById(filterId);

      if (mainBox.className.indexOf('kuCollapse') !== -1) {
        mainBox.className = 'kuFilterHead kuExpand';
        nameBox.style.display = 'none';
        if (showBox) {
          showBox.style.display = 'none';
        }
        if (hideBox) {
          hideBox.style.display = 'none';
        }
        klevu_landingFilters.filterHeight = filterBox.style.height;
        filterBox.style.height = "50px";
      } else if (mainBox.className.indexOf('kuExpand') !== -1) {
        mainBox.className = 'kuFilterHead kuCollapse';
        nameBox.style.display = 'block';
        if (showBox) {
          showBox.style.display = 'block';
        }
        if (hideBox) {
          hideBox.style.display = 'none';
        }
        if (showBox && hideBox) {
          klevu_landingFilters.hideAll(filterId);
        } else {
          filterBox.style.height = 'auto';
        }
      }
    },

    showFiltersOnMobile: function (updateRefineByDiv) {
      var doc = document,
        filtersDiv = doc.getElementById('kuFilters'),
        narrowByDiv = doc.getElementById('kuFilterRefineMobile');
      updateRefineByDiv = typeof updateRefineByDiv !== 'undefined' ? updateRefineByDiv : true;
      if (narrowByDiv.className.indexOf('kuCollapse') !== -1) {
        if (updateRefineByDiv) {
          narrowByDiv.className = 'kuFilterRefineMobile kuExpand';
          //filtersDiv.style.cssText += ";display : none !important;";
        } else {
          //filtersDiv.style.cssText += ";display : block !important;";
        }

      } else if (narrowByDiv.className.indexOf('kuExpand') !== -1) {
        if (updateRefineByDiv) {
          narrowByDiv.className = 'kuFilterRefineMobile kuCollapse';
          //filtersDiv.style.cssText += ";display : block !important;";
        } else {
          //filtersDiv.style.cssText += ";display : none !important;";
        }
        var filterBoxes = getElementsByClassName('kuFilterHead', 'div');
        for (var i = 0, len = filterBoxes.length; i < len; i++) {
          if (filterBoxes[i].className.indexOf('kuCollapse') !== -1) {
            filterBoxes[i].click();
          }
        }
      }
    }
  },
  showLandingPageData: function (product) {

    var toReturn = '',
      toAppendwithSalePrice = '',
      priceWithCurrency = '',
      appendCurrencyAtLast = false,
      salepriceClass = 'kuSalePrice',
      priceFormatter, priceToSet,
      showToLabel = false,
      additionalParams = '',
      keywords = document.getElementById('searchedKeyword').value,
      trackingParams = "",
      trackingEventHtml = "",
      i = 0,
      currentSwatch, swatchEventHandlerHtml,
      swatchFocusHandler, swatchBlurHandler, swatchColor,
      swatchCount = 0,
      swatchesShown = false,
      swatchesHtml = "",
      totalSwatchesToShow = 5;

    product = klevu_productCustomizations(product);
    if (product.productImage.trim().length === 0) {
      product.productImage = klevu_userOptions.noImageUrl;
    }

    if (klevu_apiKey === 'klevu-13939350527231') {
      toAppendwithSalePrice = '<span class="priceGreyText">Starting Price</span>';
    }

    if (klevu_userOptions.openProductClicksInNewWindow) {
      additionalParams = ' target="_blank"';
    } else {
      additionalParams = ' onclick="klevu_analytics.stopClickDefault( event );"';
    }
    trackingParams = '{' +
      'data: {' +
      'code: \'' + escape(product.productCode) + '\',' +
      'url: \'' + escape(product.productUrl) + '\',' +
      'name: \'' + escape(product.productName) + '\',' +
      'salePrice: \'' + escape(product.salePrice) + '\',' +
      'rating: \'' + escape(product.rating) + '\',' +
      'position: ' + product.productPosition + ',' +
      'category: \'' + escape(product.category) + '\',' +
      'sku: \'' + escape(product.sku) + '\'' +
      '},' +
      'apiKey: null,' +
      'keywordsLP: \'' + escape(keywords) + '\'' +
      '}';

    if (klevu_commons.isMobileDevice()) {
      trackingEventHtml = ' onclick="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" >';
    } else {
      trackingEventHtml = ' onmousedown="return klevu_analytics.trackClickedProduct(event, ' + trackingParams + ');" ' + additionalParams + '>';
    }
    try {
      // code for the result block
      toReturn += '<li>';
      toReturn += '<div class="klevuImgWrap">';
      toReturn += '<a href="' + product.productUrl.replace(/"/g, "%22") + '" ';
      if (klevu_userOptions.showRolloverImage && product.imageHover) {
        toReturn += ' onmouseleave = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage.replace('_medium', '')) + '\', \'klevuProductImage-' + product.id + '\');" ' +
          ' onmouseenter = "klevu_commons.updateProductThumbnailImage(\'' + escape(product.imageHover.replace('_medium', '')) + '\', \'klevuProductImage-' + product.id + '\');" ';
      }
      toReturn += ' target="_blank" ' + trackingEventHtml +
        '<img id= "klevuProductImage-' + product.id + '" src="' + product.productImage.replace('_medium', '') + '" onerror="this.onerror=null;this.src=\'' +
        klevu_userOptions.noImageUrl + '\';" alt="' + klevu_commons.escapeHtml(product.productName) + '"/>';

      toReturn += '</a>';

      if (klevu_commons.showAddToCartButton(product.inStock, product.hideAddToCart)) {
        if (!(product.isCustomOptionsAvailable && product.isCustomOptionsAvailable === "yes") &&
          (!product.totalProductVariants || product.totalProductVariants == '0')) {
          toReturn += '<div class="kuAddtocart">' +
            '<input type="text" name="klevu-qty" id="klevu-qty-' +
            escape(product.productCode) + '" placeholder="' +
            klevu_uiLabels.addToCartPlaceholder + '"/>' +
            '<a href="javascript:klevu_lpSendProductToCart(\'' +
            escape(product.productCode) + '\', \'' +
            escape(product.productUrl) + '\', \'klevu-qty-' +
            escape(product.productCode) + '\');" ' +
            'class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
            '</div>';
        } else {
          toReturn += '<div class="kuAddtocart">' +
            '<a href="' + product.productUrl.replace(/"/g, "%22") +
            '" class="kuAddtocartBtn">' + klevu_userOptions.addToCartButton + '</a>' +
            '</div>';
        }
        toReturn += '<div class="klevu-clearboth-listview"></div>';
      }


      toReturn += '</div>'; //closing image wrap

      if (klevu_userOptions.showProductSwatches && product.swatches && product.swatches.swatch && product.swatches.swatch.length > 0) {
        totalSwatchesToShow = product.swatches.swatch.length > totalSwatchesToShow ? totalSwatchesToShow : product.swatches.swatch.length;
        for (i = 0; i < totalSwatchesToShow; i++) {
          currentSwatch = product.swatches.swatch[i];
          if (currentSwatch.image) {
            swatchesShown = true;
            swatchColor = currentSwatch.color.replace(/ /g, "").replace(/-/g, "");
            if (!currentSwatch.swatchImage && !klevu_commons.isValidCSSColor(swatchColor)) {
              swatchesHtml += '<div class="klevuSwatchItem klevuDefaultSwatch">';
            } else {
              swatchesHtml += '<div class="klevuSwatchItem">';
            }
            swatchFocusHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(currentSwatch.image) + '\', \'klevuProductImage-' + product.id + '\');';
            swatchBlurHandler = 'klevu_commons.updateProductThumbnailImage(\'' + escape(product.productImage) + '\', \'klevuProductImage-' + product.id + '\');';
            if (klevu_commons.isMobileDevice()) {
              swatchEventHandlerHtml = ' onclick = "' + swatchFocusHandler + '" ';
            } else {
              swatchEventHandlerHtml = ' onmouseleave = "' + swatchBlurHandler + '" onmouseenter = "' + swatchFocusHandler + '" ';
            }

            swatchesHtml += '<a href = "javascript:void(0);" class = "klevuSwatchLink" ' + swatchEventHandlerHtml;
            swatchesHtml += ' style = "background-color:' + swatchColor +
              '; background-image:url(\'' + currentSwatch.swatchImage + '\');" title="' + currentSwatch.color + '">';
            swatchesHtml += '</a></div>';
          } else {
            swatchCount += 1;
          }
        }
        if (product.swatches.swatch.length > totalSwatchesToShow) {
          swatchCount += product.swatches.swatch.length - totalSwatchesToShow;
        }
        if (!swatchesShown) {
          swatchesHtml = '<div class="klevuSwatches" style="display:none;">' + swatchesHtml;
        } else {
          swatchesHtml = '<div class="klevuSwatches">' + swatchesHtml;
        }
        swatchCount += (product.swatches.numberOfAdditionalVariants ? +(product.swatches.numberOfAdditionalVariants) : 0);
        if (swatchCount > 0 && swatchesShown) {
          swatchesHtml += '<div class = "klevuSwatchItem klevuSwatchMore">' +
            '<a href = "' + product.productUrl.replace(/"/g, "%22") + '" class = "klevuSwatchLink"' + trackingEventHtml +
            '<span class = "klevuSwatchMoreText">+' + swatchCount + '</span></a></div>';
        }

        swatchesHtml += '</div>';
        toReturn += swatchesHtml;
      }
    } catch (e) {}

    if ('undefined' !== typeof klevu_showDiscountBadge &&
      klevu_showDiscountBadge && product.discount != '' &&
      product.discount != '0' && product.discount != '0.0') {
      if (klevu_uiLabels.discountBadgeText.indexOf("#") === -1) {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText + ' ' +
          Number(product.discount).toFixed(0) +
          '%</div>';
      } else {
        toReturn += '<div class="kuDiscountBadge">' +
          klevu_uiLabels.discountBadgeText.replace("#", Number(product.discount).toFixed(0) + "%") +
          '</div>';
      }
    }
    toReturn += '<div class="kuNameDesc">';
    toReturn += '<div class="kuName"><a href="' + product.productUrl.replace(/"/g, "%22") +
      '" target="_blank" ' + trackingEventHtml;
    toReturn += product.productName + '</a></div>';
    toReturn += '<div class="kuDesc">' + product.productDescription + '</div>';
    if (product.rating.trim().length > 0 && !isNaN(Number(product.rating)) &&
      Number(product.rating) <= 5 && Number(product.rating) >= 0) {
      var starWidth = 20 * Number(product.rating);
      toReturn += '<div class="kuStarsSmall">' +
        '<div class="kuRating" style="width:' + starWidth +
        '%;"></div></div>';
    }
    toReturn += '</div>';

    toReturn += '<div class="kuPrice">';
    if (klevu_showPrices) {
      if (klevu_userOptions.showOnlyOriginalAndSalePrices) {
        toReturn += klevu_commons.showOriginalAndSalePrices('LANDING', product,
          salepriceClass, 'kuSalePrice kuSpecialPrice');
      } else {
        toReturn += klevu_commons.showProductPrices('LANDING', product,
          salepriceClass, 'kuSalePrice kuSpecialPrice');
      }
    }

    if (klevu_userOptions.vatCaption.trim().length > 0) {
      toReturn += '<div class="klevu-vat-caption">(' + klevu_userOptions.vatCaption + ')</div>';
    }

    if (product.totalProductVariants && product.totalProductVariants != '0' && !swatchesShown) {
      if (klevu_uiLabels.variants.indexOf("#") === -1) {
        toReturn += '<div class="klevu-variants">+' + product.totalProductVariants +
          ' ' + klevu_uiLabels.variants + '</div>';
      } else {
        toReturn += '<div class="klevu-variants">' +
          klevu_uiLabels.variants.replace("#", product.totalProductVariants) + '</div>';
      }
    }
    if (klevu_userOptions.outOfStockCaption.trim().length > 0) {
      if ((product.inStock) && product.inStock === 'no') {
        toReturn += '<div class="klevu-out-of-stock">' +
          klevu_userOptions.outOfStockCaption + '</div>';
      }
    }

    toReturn += '</div>';

    toReturn += '<div class="kuClearLeft"></div>';
    toReturn += '</li>';

    return toReturn;
  }



}



function klevu_afterLandingResultsLoaded(results) {

  ApplyFilters();

  if (klevu_commons.isMobileDevice()) {

    if (firstVisit) {
      document.getElementById('smallWidthButton').click();
      firstVisit = false;
    }

    CollapseAllFilters();
  }

  document.querySelector('.search-header').style.display = "";


}

function addClassToBody(className) {
  document.querySelector('body').classList.add(className);
}

function createNewHeaderAndFilterButtons() {

  var FullWidthButton = '<button id="FullWidthButton"><svg xmlns="http://www.w3.org/2000/svg" width="35" viewBox="0 0 23 10.03" fill="#000">' +
    '<g data-name="Group 587">' +
    '<path d="M3.54 0h2.95v2.95H3.54z" data-name="Rectangle 627"></path>' +
    '<path d="M3.54 3.54h2.95v2.95H3.54z" data-name="Rectangle 638"></path>' +
    '<path d="M3.54 7.08h2.95v2.95H3.54z" data-name="Rectangle 642"></path>' +
    '<path d="M10.62 0h2.95v2.95h-2.95z" data-name="Rectangle 636"></path>' +
    '<path d="M10.62 3.54h2.95v2.95h-2.95z" data-name="Rectangle 640"></path>' +
    '<path d="M10.62 7.08h2.95v2.95h-2.95z" data-name="Rectangle 644"></path>' +
    '<path d="M0 0h2.95v2.95H0z" data-name="Rectangle 634"></path>' +
    '<path d="M0 3.54h2.95v2.95H0z" data-name="Rectangle 637"></path>' +
    '<path d="M0 7.08h2.95v2.95H0z" data-name="Rectangle 641"></path>' +
    '<path d="M7.08 0h2.95v2.95H7.08z" data-name="Rectangle 635"></path>' +
    '<path d="M7.08 3.54h2.95v2.95H7.08z" data-name="Rectangle 639"></path>' +
    '<path d="M7.08 7.08h2.95v2.95H7.08z" data-name="Rectangle 643"></path>' +
    '</g>' +
    '</svg></button>';

  var smallWidthButton = '<button id="smallWidthButton"><svg xmlns="http://www.w3.org/2000/svg" width="18" viewBox="0 0 11 10.03" fill="#c9c9c9">' +
    '<g id="Group_588" data-name="Group 588" transform="translate(-1225 -95)">' +
    '<path id="Rectangle_647" d="M0 0h2.95v2.95H0z" class="cls-1" data-name="Rectangle 647" transform="translate(1228.54 95)"></path>' +
    '<path id="Rectangle_648" d="M0 0h2.95v2.95H0z" class="cls-1" data-name="Rectangle 648" transform="translate(1228.54 98.54)"></path>' +
    '<path id="Rectangle_649" d="M0 0h2.95v2.95H0z" class="cls-1" data-name="Rectangle 649" transform="translate(1228.54 102.08)"></path>' +
    '<path id="Rectangle_645" d="M0 0h2.95v2.95H0z" class="cls-1" data-name="Rectangle 645" transform="translate(1225 95)"></path>' +
    '<path id="Rectangle_646" d="M0 0h2.95v2.95H0z" class="cls-1" data-name="Rectangle 646" transform="translate(1225 98.54)"></path>' +
    '<path id="Rectangle_650" d="M0 0h2.95v2.95H0z" class="cls-1" data-name="Rectangle 650" transform="translate(1225 102.08)"></path>' +
    '</g>' +
    '</svg></button>';

  var sortButton = '<button id="sortButton"><span>Sort By</span><span class="sort-button__closed">+</span><span class="sort-button_opened">-</span></button>';

  var sortList = '<ul class="sort-list">' +
    '<li><a href="javascript:void(0);" onclick="klevu_changeSortingOptionsForLandigPage(\'rel\');" title="Relevance"><span>Relevance</span></a></li>' +
    '<li><a href="javascript:void(0);" onclick="klevu_changeSortingOptionsForLandigPage(\'lth\');" title="Price: Low to High"><span>Price: Low to High</span></a></li>' +
    '<li><a href="javascript:void(0);" onclick="klevu_changeSortingOptionsForLandigPage(\'htl\');" title="Price: High to low"><span>Price: High to low</span></a></li>' +
    '</ul>';

  var ApplyResetButtons = '<div class="filter__buttons"><div><button onclick="klevu_landingFilters.clearAllFilters();">CLEAR FILTERS</button><button id="filterApply">APPLY FILTERS</button></div><div class="filter-close">×</div></div>';

  var newSearchHeader = document.createElement('div');
  newSearchHeader.className = 'search-header';
  newSearchHeader.style.display = "none";
  newSearchHeader.innerHTML = '<div class="sort-block"><div class="svg-block">' + FullWidthButton + smallWidthButton + '</div><div class="sortby-container">' + sortButton + sortList + '</div></div>';



  var filterButton = document.createElement('button');
  filterButton.className = 'filter-button';
  filterButton.innerHTML = '<span>Filter</span><span class="filter-button__closed">+</span><span class="filter-button_opened">-</span>';
  filterButton.addEventListener('click', function () {
    document.getElementById('kuMainContainer').classList.toggle('filter_opened');
    newSearchHeader.classList.remove('sort-block_opened');
  });

  newSearchHeader.insertAdjacentElement('afterbegin', filterButton);

  if (!document.querySelector('.search-header')) {
    document.getElementById('kuProListing').insertAdjacentElement('beforebegin', newSearchHeader);
  }

  if (!document.querySelector('filter__buttons')) {
    document.querySelector('#kuFilters').insertAdjacentHTML('afterend', ApplyResetButtons);
  }

  document.getElementById('filterApply').addEventListener('click', function () {
    document.getElementById('kuMainContainer').classList.toggle('filter_opened');
    newSearchHeader.classList.remove('sort-block_opened');
  });

  document.querySelector('.filter-close').addEventListener('click', function () {
    document.getElementById('kuMainContainer').classList.toggle('filter_opened');
    newSearchHeader.classList.remove('sort-block_opened');
  });

  document.getElementById('sortButton').addEventListener('click', function () {
    newSearchHeader.classList.toggle('sort-block_opened');
    document.getElementById('kuMainContainer').classList.remove('filter_opened');
  });

  document.getElementById('FullWidthButton').addEventListener('click', function (e) {
    document.getElementById('kuResultsView').classList.remove('list_small-width');
    this.querySelector('svg').setAttribute('fill', '#000');
    document.querySelector('#smallWidthButton svg').setAttribute('fill', '#c9c9c9');
  });

  document.getElementById('smallWidthButton').addEventListener('click', function (e) {
    document.getElementById('kuResultsView').classList.add('list_small-width');
    this.querySelector('svg').setAttribute('fill', '#000');
    document.querySelector('#FullWidthButton svg').setAttribute('fill', '#c9c9c9');
  });

}

function ApplyFilters() {
  var queryString = '';

  document.querySelectorAll('.kuFilterNames ul li a').forEach(function (item) {
    item.onclick = function (event) {
      event.preventDefault();
      var closestLI = event.target.closest('li');
      var replaceObj = {
        'sendQuery': "cancelFilter",
        'true': ""
      };

      var clkAttribute = item.getAttribute('onclick');
      closestLI.classList.toggle('kuSelected');

      if (item.parentElement.className.indexOf('kuSelected') !== -1) {
        queryString += clkAttribute;
      } else {
        queryString += clkAttribute.replace(/sendQuery|true/gi, function (matched) {
          return replaceObj[matched];
        });
      }
      document.getElementById('kuProListing').classList.add('filter_selected');
      document.getElementById('filterApply').setAttribute('onclick', queryString);
    }
  });
}

function CollapseAllFilters() {
  var allFacets = document.querySelectorAll('.kuFilterHead');

  allFacets.forEach(function (elem) {
    if (elem.classList.contains('kuCollapse')) {
      elem.click();
    }
  });
}